import React, {useRef} from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {Box, Card, CardContent, Tooltip} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Info from '@mui/icons-material/Info';
import {IConfigSchema} from '../resources/config-schema';
import {EXPORTING} from '@/utils/constants';

interface IChartsContainerProps {
    configSchema: IConfigSchema,
    usePercentage?: boolean,
    legendEnabled?: boolean,
}

export function ChartContainer({configSchema, usePercentage = false, legendEnabled = true}: IChartsContainerProps) {
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

    return (
        <Box>
            <Box className='section-title'>
                <Box>
                    {configSchema.title}
                </Box>
                <Tooltip
                    title={<>
                        <span dangerouslySetInnerHTML={{__html: configSchema.tooltip}}/>
                    </>}
                >
                    <IconButton>
                        <Info fontSize='small'/>
                    </IconButton>
                </Tooltip>
            </Box>
            <Card>
                <CardContent>
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={{
                            chart: {
                                height: 400,
                                type: configSchema.type,
                                style: {
                                    fontFamily: 'Rubik, sans-serif'
                                },
                                backgroundColor: '#fafafa'
                            },
                            title: {
                                text: '',
                            },
                            legend: {
                                enabled: legendEnabled
                            },
                            xAxis: {
                                categories: configSchema.categories
                            },
                            series: configSchema.series,
                            exporting: EXPORTING,
                            ...(
                                usePercentage && {
                                    yAxis: {
                                        min: 0,
                                        max: 100,
                                        labels: {
                                            format: '{value}%'
                                        },
                                        title: {
                                            text: ''
                                        }
                                    },
                                    tooltip: {
                                        valueSuffix: '%'
                                    },
                                }
                            )
                        }}
                        ref={chartComponentRef}
                    />
                </CardContent>
            </Card>
        </Box>
    )
}